import axiosInstance from "./axiosInstance";

export const getCorporationData = (params) => {
  return axiosInstance.get(`corporation/account`, { params: params });
};

export const updateCorporationDocuments = (documents) => {
  return axiosInstance.put("corporation/documents", { documents });
};
